import React from 'react';
import Input from '../../../../../../../components/Input/Input';
import { useLocation } from 'react-router-dom';
import './SupportGroupData.css';

const SupportGroupData = () => {
  const location = useLocation();
  const { supportData } = location.state || {};

  const mockData = {
    supportFolio: 'Support folio',
    requestedBy: 'User name',
    group: 'Name group',
    email: 'Correo@gmail.com',
    reason: 'Reason',
    dateOfRequest: '11/16/1997',
    status: 'Active'
  };

  const data = supportData || mockData;

  return (
    <div className="support-data-container">
      <h2 className="support-title">
        Group <span className="title-highlight">support</span>
      </h2>

      <div className="support-form">
        <div className="form-row">
          <div className="form-field">
            <h3>Support folio</h3>
            <Input
              type="text"
              value={data.supportFolio}
              disabled
            />
          </div>
          <div className="form-field">
            <h3>Who request it</h3>
            <Input
              type="text"
              value={data.requestedBy}
              disabled
            />
          </div>
          <div className="form-field">
            <h3>Group</h3>
            <Input
              type="text"
              value={data.group}
              disabled
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-field">
            <h3>E-mail</h3>
            <Input
              type="text"
              value={data.email}
              disabled
            />
          </div>
          <div className="form-field">
            <h3>Reason</h3>
            <Input
              type="text"
              value={data.reason}
              disabled
            />
          </div>
          <div className="form-field">
            <h3>Date of request</h3>
            <Input
              type="text"
              value={data.dateOfRequest}
              disabled
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-field">
            <h3>Status</h3>
            <Input
              type="text"
              value={data.status}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportGroupData;
